var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDividerShort = function SvgDividerShort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 16,
    viewBox: "0 0 263 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_9151_184186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.207 14.7C134.077 14.72 127.947 14.74 121.817 14.76L114.867 7.80999L121.817 0.859985C127.977 0.859985 134.137 0.859985 140.297 0.859985C142.597 3.17999 144.897 5.49999 147.197 7.82999C144.867 10.12 142.537 12.41 140.207 14.71V14.7ZM139.427 12.77L144.377 7.81999C142.717 6.15999 141.057 4.50999 139.397 2.84999C133.817 2.84999 128.237 2.84999 122.647 2.84999L117.697 7.79999C119.427 9.44999 121.157 11.1 122.897 12.75C128.407 12.75 133.917 12.75 139.427 12.75V12.77Z",
    fill: "#0E134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.04 10.61C132.305 10.61 133.33 9.58476 133.33 8.32003C133.33 7.0553 132.305 6.03003 131.04 6.03003C129.775 6.03003 128.75 7.0553 128.75 8.32003C128.75 9.58476 129.775 10.61 131.04 10.61Z",
    fill: "#0E134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.291 7.32001H158.211V9.32001H188.291V7.32001Z",
    fill: "#0E134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.331 15.64L145.531 7.83002L153.331 0.0300195L262.651 0.0200195V2.02002L154.161 2.03002L148.351 7.83002L154.161 13.64L192.631 13.61V15.61L153.331 15.64Z",
    fill: "#0E134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.432 7.29999H75.3516V9.29999H105.432V7.29999Z",
    fill: "#0E134C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.32 15.62L70.02 15.59V13.59L108.49 13.62L114.29 7.82L108.49 2.01L0 2V0L109.32 0.01L117.12 7.82L109.32 15.62Z",
    fill: "#0E134C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9151_184186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.65,
    height: 15.64,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDividerShort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Divider_short.ca9a9407.svg";
export { ForwardRef as ReactComponent };